export default __webpack_public_path__ + "static/09_GrasshoppersLieHeavy-a9ced49ffa04a7b80a721bddf0bf6e4e.pdf";